<template>
  <div>
    <tabs v-model="active" sticky>
      <tab v-for="(item, index) in tabs" :key="index" :title="item.title">
        <list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div
            class="wz"
            v-for="(item, index) in list"
            :key="index"
            @click="
              $router.push({ path: '/wzdetails', query: { id: item.id } })
            "
          >
            <div class="wz-pos">
              <van-image
                fit="cover"
                width="100%"
                height="100%"
                :src="item.thumb"
                alt=""
              />
            </div>
            <div
              style="
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
              "
            >
              <div class="wz-title">
                <p>{{ item.title }}</p>
              </div>
              <div class="wz-time">
                <span>{{ item.time }}</span>
                <span>已有{{ item.read }}人阅读</span>
              </div>
            </div>
          </div>
        </list>
      </tab>
    </tabs>
  </div>
</template>

<script>
/**
@description:文章列表
@createTime:2021-09-17
@create:wq
*/

import { Tab, Tabs, List } from "vant";
export default {
  name: "",
  props: {},
  components: { Tab, Tabs, List },
  data() {
    return {
      active: 0,
      tabs: [],
      loading: false,
      finished: false,
      page: 1,
      list: [],
    };
  },
  computed: {},
  watch: {
    active() {
      this.list = [];
      this.page = 1;
      this.getList();
    },
  },
  mounted() {},
  created() {
    this.articleCate();
  },
  methods: {
    articleCate() {
      this.api.articleCate().then((res) => {
        this.tabs = res.data;
        // if (this.tabs.length) {
        //   this.getList();
        // }
      });
    },
    getList() {
      const cid = this.tabs[this.active].id;
      this.api.articleList({ cid: cid, page: this.page }).then((res) => {
        this.list = [...this.list, ...res.data.data];
        if (res.data.to < res.data.per_page) {
          this.loading = true;
          this.finished = true;
        } else {
          this.loading = false;
        }
      });
    },
    onLoad() {
      this.getList();
      this.page++;
    },
  },
};
</script>
<style lang="scss" scoped>
.wz {
  margin: 0.4rem 0.24rem;
  padding: 0.32rem 0 0.26rem;
  display: flex;
  border-bottom: 1px dotted #888888;
  .wz-pos {
    // flex-shrink: 0;
    width: 2.15rem;
    height: 1.62rem;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 0.32rem;
    img {
      width: 100%;
    }
  }
  .wz-title {
    width: 100%;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .wz-time {
    width: 100%;
    margin-top: 0.3rem;
    font-size: 0.24rem;
    font-weight: 300;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>
